import React, { useMemo } from 'react';
import { NewInlineDateTimeInput } from '@sonika-se/ui-kit/components';
import { useFragment, graphql, useMutation } from 'react-relay/hooks';
import { usePermissions } from '@sonika-se/ui-kit/hooks';
import { formatISO } from 'date-fns';
export const EditScheduleShiftTimeEnd = (props) => {
    const { scheduleShift, placeholder } = props;
    const hasPermissions = usePermissions();
    const { id, end, schedule } = useFragment(graphql `
      fragment EditScheduleShiftTimeEnd on ScheduleShift {
        id
        end
        schedule {
          currentUserPermissions
        }
      }
    `, scheduleShift);
    const [updateScheduleShiftTime, updateScheduleShiftTimeLoading] = useMutation(graphql `
      mutation EditScheduleShiftTimeEndMutation($model: UpdateScheduleShiftTimeRequestInput!) {
        updateScheduleShiftTime(model: $model) {
          shiftEdge {
            node {
              id
              end
            }
          }
          scheduleShiftHistoryTimeChangeEdge {
            node {
              id
              scheduleShift {
                ...ScheduleShift_shift
                ...ScheduleShiftHistory_scheduleShift
              }
              ...ScheduleShiftHistoryTimeChange_history
            }
          }
        }
      }
    `);
    const canEditRunning = useMemo(() => hasPermissions(['EDIT_SCHEDULES']) || schedule.currentUserPermissions.includes('EDIT_RUNNING'), [hasPermissions, schedule]);
    return (<NewInlineDateTimeInput defaultValue={end ? new Date(end) : null} disabled={!canEditRunning || updateScheduleShiftTimeLoading} placeholder={placeholder} displayActionButtons header="Välj sluttid" onChange={(date) => {
            if (!date)
                return;
            updateScheduleShiftTime({
                variables: {
                    model: {
                        shiftId: id,
                        end: formatISO(date),
                    },
                },
                optimisticResponse: {
                    updateScheduleShiftTime: {
                        shiftEdge: {
                            node: {
                                id,
                                end: formatISO(date),
                            },
                        },
                        scheduleShiftHistoryTimeChangeEdge: {
                            node: {
                                id: '2',
                                scheduleShift: null,
                                byUser: null,
                                newEnd: end,
                                newStart: date,
                                originalBreaks: null,
                                newBreaks: null,
                                originalEnd: end,
                                originalStart: end,
                                timestamp: end,
                            },
                        },
                    },
                },
            });
        }}/>);
};
export default EditScheduleShiftTimeEnd;
